import { useState, useEffect } from 'react';
import { api } from '@/shared/api/axios';

export interface AccAccount {
  _id: string;
  code: string;
  name: string;
  type: 'asset' | 'liability' | 'equity' | 'income' | 'cogs' | 'expense';
  parentCode?: string;
  isGroupHeader?: boolean;
  isControlAccount?: boolean;
  allowManualPosting?: boolean;
  isSystem?: boolean;
  balanceMinor?: number;
}

export function useChartOfAccounts() {
  const [accounts, setAccounts] = useState<AccAccount[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAccounts = async () => {
    setLoading(true);
    try {
      const res = await api.get('/api/accounting/accounts');
      const data = res.data;
      if (data.ok || data.success) {
        const list = Array.isArray(data.data) ? data.data : data.data?.items || [];
        setAccounts(list);
      } else {
        setError(data.error?.message || 'Failed to load accounts');
      }
    } catch (err: any) {
      setError(err.response?.data?.error?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  return { accounts, loading, error, refresh: fetchAccounts };
}
